import { cn } from "@/lib/utils";

export default function IconAdd({ className }: { className?: string }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="currentColor" className={cn("size-6", className)}>
			<path d="M13.5 7H11.5V11H7.5V13H11.5V17H13.5V13H17.5V11H13.5V7Z" fill="inherit" />
			<path
				d="M12.5 2C6.986 2 2.5 6.486 2.5 12C2.5 17.514 6.986 22 12.5 22C18.014 22 22.5 17.514 22.5 12C22.5 6.486 18.014 2 12.5 2ZM12.5 20C8.089 20 4.5 16.411 4.5 12C4.5 7.589 8.089 4 12.5 4C16.911 4 20.5 7.589 20.5 12C20.5 16.411 16.911 20 12.5 20Z"
				fill="inherit"
			/>
		</svg>
	);
}
